import React from "react"
import Button from "@mui/material/Button";
import ArrowBack from "@mui/icons-material/ArrowBack";
import {useTranslation} from "react-i18next";
import {useRouter} from "next/router";

interface Props {
    buttonLabelKey: string
    backUri?: string
    customStyle?: any
    className?: string
    onClick?: () => void
}

function CCOBackButton(props: Props) {
    const {t} = useTranslation();
    const router = useRouter();
    const handleOnClick = () => {
        if (props.onClick) {
            props.onClick();
        }
        router.push(props.backUri!).then(() => {
        });
    }
    return props.backUri ?
        <Button className={props.className} data-cypress='backButton'
                onClick={handleOnClick}
                startIcon={<ArrowBack/>}
                sx={{...props.customStyle}}>
            {t(props.buttonLabelKey)!}
        </Button> : null
}

export default CCOBackButton